<script setup lang="ts">
import { inject } from 'vue'
import { useChapterTheme } from '../composables/useChapterTheme'
import ReaderMenu from '@/components/ReaderMenu.novelsprig.vue'
import type { ChapterConfig } from '@/composables/payment'

defineProps<{ value: boolean; chapter: any; chapterNumber: number; totalChapters: number }>()
const emit = defineEmits<{
  (event: 'input', value: boolean): void
  (event: 'prev-chapter'): void
  (event: 'next-chapter'): void
  (event: 'open-toc'): void
}>()
const config = inject<ChapterConfig>('chapterConfig')!
const { theme, THEME_BACKGROUNDS, THEME_FONT_MAP, onChangeThemeSize, THEME_SKINS, setSkin } = useChapterTheme()
</script>

<template>
  <ReaderMenu
    :value="value" :chapter="chapter" :chapter-number="chapterNumber" :total-chapters="totalChapters"
    :theme="theme" :backgrounds="['#F8FBF8', ...THEME_BACKGROUNDS]" :font-map="THEME_FONT_MAP"
    :size-label="config.texts.themeSizeLabel" :decrease-label="config.texts.fontSizeDecrease"
    :increase-label="config.texts.fontSizeIncrease" :prev-label="config.texts.prevButton" :next-label="config.texts.nextButton"
    :skins="THEME_SKINS" @input="emit('input', $event)" @prev-chapter="emit('prev-chapter')"
    @next-chapter="emit('next-chapter')" @open-toc="emit('open-toc')" @change-size="onChangeThemeSize"
    @change-background="theme.background = $event; theme.skinId = ''" @change-skin="setSkin"
  />
</template>
